import { useContext } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import TEXTS from '../controller/TextVariables';

// Theme name, Dekalb County Georgia
export default function MapTitle() {
    const { theme, scope, tract, year, usState } = useContext(InterfaceContext);
    const scopeText = scope === 'national' ? TEXTS.controls.comparison.option1 : TEXTS.controls.comparison.option2;
    const stateText = scope === 'state' ? (usState.label || '___') + ': ' : '';
    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };
    const trackAdj = tract == 'census' ? 'Census Tract' : 'County';
    return (
        <div id="title" className="field wide">
            <h2 className={'icon-' + theme.icon}>
                <strong>{theme.label}</strong>
            </h2>
            <h3>
                <span className="for-screen-reader">United States</span>
                {stateText} {scopeText} Comparison
            </h3>
            <h4>
                By {trackAdj} | {year.label}
            </h4>
        </div>
    );
}
